// extracted by mini-css-extract-plugin
module.exports = {"button":"JobSettingModal_button__2W4NC","headerTitle":"JobSettingModal_headerTitle__1fmtZ"};